export const SUPER_GIFTING_EXPIRY_DATE = '2023-06-01';
